import { shouldPolyfill } from '@formatjs/intl-numberformat/should-polyfill'

export default async function polyfill (): Promise<void> {
  if (typeof shouldPolyfill() !== 'undefined' && shouldPolyfill() !== null) {
    // Load the polyfill 1st BEFORE loading data
    await import('@formatjs/intl-numberformat/polyfill')
  }

  if ((Intl.NumberFormat as any).polyfilled !== null) {
    await import('@formatjs/intl-numberformat/locale-data/es')
    await import('@formatjs/intl-numberformat/locale-data/en')
  }
}
